import { Component, defineElement, FC, onDidLoad, useBindMethod } from '@atomify/hooks';
import { inviewObserver } from '@source/utilities/inview';

const HIDE_HOOK = '[js-hook-chat-bubble-hide]';
const SHOW_CLASS = 'chat-bubble--show';
const DEFAULT_ELEMENTS = 'bpd-map-switch, bpd-map, bpd-krpano';

export interface ChatBubbleProps extends Component {
    addElement: (node: HTMLElement) => void;
}

interface ChatBubbleElement {
    node: HTMLElement;
    inView: boolean;
}

const ChatBubble: FC = ({ element }) => {
    const elements: ChatBubbleElement[] = [];

    onDidLoad(() => {
        getElements();

        updateVisibility();
    });

    useBindMethod('addElement', addElement);

    function getElements() {
        const defaultElements = Array.from(
            document.querySelectorAll<HTMLElement>(DEFAULT_ELEMENTS),
        );
        const elements = Array.from(document.querySelectorAll<HTMLElement>(HIDE_HOOK));

        [...defaultElements, ...elements].map(addElement);
    }

    function addElement(element: HTMLElement) {
        const newElement: ChatBubbleElement = {
            node: element,
            inView: false,
        };

        elements.push(newElement);

        observeElement(newElement);
    }

    function observeElement(element: ChatBubbleElement) {
        inviewObserver.observe(
            element.node,
            inView => {
                element.inView = inView;

                updateVisibility();
            },
            {
                rootMargin: '-80% 0px 0px 0px',
            },
        );
    }

    function updateVisibility() {
        const hasInviewElements = !!elements.find(({ inView }) => !!inView);

        if (hasInviewElements) {
            element.classList.remove(SHOW_CLASS);
        } else {
            element.classList.add(SHOW_CLASS);
        }
    }
};

defineElement('chat-bubble', ChatBubble);
